import React from 'react';
import styled, { css } from 'styled-components';

import Divider from '@material-ui/core/Divider';

const PaddedDivider = styled(({ spacing, hide, ...other }) => (
  <Divider {...other} />
))`
  margin: ${props => (props.spacing == null ? '2' : props.spacing)}em 0;
  ${props =>
    props.hide &&
    css`
      background-color: transparent;
    `}
`;

export default PaddedDivider;
